import { TypographyOptions } from '@material-ui/core/styles/createTypography'
import Palette from './palette'

const typography: TypographyOptions = {
  fontFamily: ['Raleway', 'Helvetica', 'Arial'].join(','),
  fontSize: 14,
  fontWeightRegular: 400,
  body1: {
    fontSize: 14,
    fontWeight: 500,
    color: Palette.common.black,
  },
  body2: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(0,0,0,0.6)',
  },
  h3: {
    fontSize: 35,
    color: Palette.common.black,
    fontWeight: 600,
  },
  h4: {
    fontSize: 28,
    fontWeight: 900,
    color: Palette.common.black,
  },
  h5: {
    fontWeight: 1000,
    fontSize: 18,
    color: Palette.common.black,
  },
  h6: {
    fontWeight: 500,
    fontSize: 18,
    color: Palette.common.black,
  },
}

export default typography
